export enum LDFeatureFlags {
    BannerGamesDisplayType = 'ld16-gyml_row_display_type',
    BetslipMode = 'ld18-betslip_test_spain_bab',
    DefaultStreamingTab = 'ld_13-edp_streaming_tab',
    DisplayMode = 'DisplayMode',
    ESoccerInAZMenu = 'ld14-esoccer_added_to_az',
    EnableLiveAlerts = 'EnableLiveAlerts',
    ExampleFlag = 'ldx-example-for-non-breaking-unit-testing',
    FavouritesNavigationMenuPosition = 'ld11-sports_top_navigation_bar_favourites_position',
    PlayerStatsTracking = 'ld15-player_stats_bet_tracking',
    ReuseSelections = 'MyBetsReuseSelections',
    SportsHomeScreenYourFavouritesWidget = 'ld12-sports_homescreen_your_favourites_widget2',
    TennisBetTracking = 'ld17-tennis_market_bet_tracking',
    SportsQuickLinkMode = 'sports_quick_links_mode',
    EnableTabbedMultiPod = 'sports_enable_popular_picks',
    CashoutIndicator = 'ld19_cashout_value_indicator',
    MyBetsUpsellModuleDisplay = 'ld20_upsell_post_cashout',
    EnableLogPlaceBetTracking = 'tech_flag_log_place_bet_tracking',
}
export const LD_FEATURE_FLAG_STORAGE_KEY = 'LdFeatureFlags';
export const LD_FEATURE_FLAGS = [LDFeatureFlags.BetslipMode, LDFeatureFlags.DisplayMode];

export interface LaunchDarklyFlagTypes {
    [LDFeatureFlags.SportsHomeScreenYourFavouritesWidget]: boolean;
    [LDFeatureFlags.FavouritesNavigationMenuPosition]: number;
    [LDFeatureFlags.ExampleFlag]: boolean;
}
